import React from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

function Language(props) {
    const { i18n } = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        if (lang === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (lang === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }
    };

   
    return (
        <>
            {i18next.language === 'ar' ? (
                <li
                    className={`${
                        props.inverted === true
                            ? 'nav-item-inverted'
                            : 'nav-item'
                    }`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => changeLanguage('en')}
                >
                    <p
                        className={`${
                            props.inverted === true
                                ? 'nav-link-inverted'
                                : 'nav-link'
                        }`}
                    >
                        English
                    </p>
                </li>
            ) : (
                <li
                    className={`${
                        props.inverted === true
                            ? 'nav-item-inverted'
                            : 'nav-item'
                    }`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => changeLanguage('ar')}
                >
                    <p
                        className={`${
                            props.inverted === true
                                ? 'nav-link-inverted'
                                : 'nav-link'
                        }`}
                    >
                        عربي
                    </p>
                </li>
            )}
        </>
    );
}

export default Language;
